import { IonButton, IonIcon, useIonRouter } from "@ionic/react";
import { GroupChannel } from "@sendbird/chat/groupChannel";
import { useSendbirdStateContext } from "@wearesweet/sendbird-uikit-react";
import sendbirdSelectors from "@wearesweet/sendbird-uikit-react/sendbirdSelectors";
import { t } from "i18next";
import { addCircle } from "ionicons/icons";
import React, { useContext, useState } from "react";
import { debug } from "../../../App";
import { SelectMembersModal } from "../../../components/SelectMembersModal";
import { AuthenticatedUserContext } from "../../../contexts/AuthenticatedUserContext";
import { useViewport } from "../../../utils/useViewport";

export const CreateChannel = (props: any) => {
  const { member } = useContext(AuthenticatedUserContext);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const router = useIonRouter();
  const globalStore = useSendbirdStateContext();
  const { isMobile } = useViewport();
  const createGroupChannel = sendbirdSelectors.getCreateGroupChannel(globalStore);

  return member?.member_type?.can_create_chats_with !== "nobody" ? (
    <>
      <IonButton
        fill={"clear"}
        onClick={() => {
          setModalIsOpen(true);
        }}
        slot={props.slot || ""}
        className={"open-modal"}
      >
        <IonIcon slot={"icon-only"} icon={addCircle} />
      </IonButton>

      <SelectMembersModal
        next={t("Next")}
        title={t("createChannel")}
        isOpen={modalIsOpen}
        onDidDismiss={() => {
          setModalIsOpen(false);
        }}
        onSelected={(selectedMembers: string[]) => {
          const newChannelParams = {
            invitedUserIds: [member!.id.toString(), ...selectedMembers],
            isDistinct: true,
            operatorUserIds: [member!.id.toString()],
            customType: "c",
            name: "Group Channel", // default, meaning we'll generate a channel name at runtime
          };

          createGroupChannel(newChannelParams)
            .then((value: GroupChannel) => {
              setModalIsOpen(false);
              debug("Created channel", value);
              const chatEndpoint = isMobile ? "mchat" : "chat";
              router.push(`/${chatEndpoint}/channels/${value.url}/`);
            })
            .catch((error: any) => {
              alert(error);
            });
        }}
      />
    </>
  ) : (
    <></>
  );
};
